<template>
  <CModal
    title="Detalle de importación"
    color="info"
    :show.sync="modalShow"
    class="basic-modal-color"
    size="xl"
  >
    <CRow class="mb-3">
      <CCol md="4"><strong>Creados:</strong> {{ Number(safeSummary.created_count || 0) }}</CCol>
      <CCol md="4"><strong>Actualizados:</strong> {{ Number(safeSummary.updated_count || 0) }}</CCol>
      <CCol md="4"><strong>Errores:</strong> {{ Number(safeSummary.error_count || 0) }}</CCol>
    </CRow>

    <CRow class="mb-3">
      <CCol md="12">
        <label class="d-block mb-1">Filtrar por acción</label>
        <CSelect :value="filterAction" :options="actionOptions" @change="onFilterChange" />
      </CCol>
    </CRow>

    <ImportHistoryDetailTable :rows="rows" />

    <template #footer>
      <CButton color="secondary" @click="$emit('update:show', false)">Cerrar</CButton>
    </template>
  </CModal>
</template>

<script>
import ImportHistoryDetailTable from './ImportHistoryDetailTable.vue'

export default {
  name: 'ImportHistoryDetailModal',
  components: { ImportHistoryDetailTable },
  props: {
    show: { type: Boolean, default: false },
    rows: { type: Array, default: () => [] },
    summary: { type: Object, default: () => ({}) },
    filterAction: { type: String, default: 'all' }
  },
  data() {
    return {
      actionOptions: [
        { label: 'Todos', value: 'all' },
        { label: 'Creados', value: 'created' },
        { label: 'Actualizados', value: 'updated' },
        { label: 'Ignorados', value: 'skipped' },
        { label: 'Errores', value: 'error' }
      ]
    }
  },
  computed: {
    safeSummary() {
      return this.summary || {}
    },
    modalShow: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    }
  },
  methods: {
    onFilterChange(event) {
      this.$emit('change-filter', event.target.value)
    }
  }
}
</script>
